const getDefaultState = () => {
    return {
        screeningStatus: 0,
        pictureUrl: '',
        incomeFile: '',
        studentFile: '',
        companyFile: '',
        nordicApiToken: false
    }
}


const state = getDefaultState()

const getters = {
    getScreeningStatus: (state) => state.screeningStatus,
    getPictureUrl: (state) => state.pictureUrl,
    getIncomeFile: (state) => state.incomeFile,
    getStudentFile: (state) => state.studentFile,
    getCompanyFile: (state) => state.companyFile,
    getNordicApiToken: (state) => state.nordicApiToken
};

const mutations = {
    resetScreeningState: (state) => Object.assign(state, getDefaultState()),
    setScreeningStatus: (state, screeningStatus) => state.screeningStatus = screeningStatus,
    setPictureUrl: (state, pictureUrl) => state.pictureUrl = pictureUrl,
    setIncomeFile: (state, incomeFile) => state.incomeFile = incomeFile,
    setStudentFile: (state, studentFile) => state.studentFile = studentFile,
    setCompanyFile: (state, companyFile) => state.companyFile = companyFile,
    setNordicApiToken: (state, token) => state.nordicApiToken = token
};

const actions = {
    async fetchScreeningStatus({commit, getters}, callback){
        if (callback == undefined) {
            callback = function() {};
        }

            const statusData = await axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/user/screening-status',
                cancelToken: window.AuthorizationCancelSource.token,
            });
            commit('setScreeningStatus', statusData.data.progress);
            commit('setIsVerified', statusData.data.isVerified);

    },
    async fetchProfileImage({commit, getters}){

            const image = await axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/user/image',
                cancelToken: window.AuthorizationCancelSource.token,
            });
            commit('setPictureUrl', image.data);
    },
    async fetchIncomeFile({commit, getters}){

            const file = await axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/user/documents?type=income',
                cancelToken: window.AuthorizationCancelSource.token,
            });
            commit('setIncomeFile', file.data);

    },
    async fetchStudentFile({commit, getters}){

            const file = await axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/user/documents?type=study',
                cancelToken: window.AuthorizationCancelSource.token,
            });
            commit('setStudentFile', file.data);

    },
    async fetchCompanyFile({commit, getters}){

            const file = await axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/user/documents?type=company',
                cancelToken: window.AuthorizationCancelSource.token,
            });
            commit('setCompanyFile', file.data);
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
